// src/pages/departments/DepartmentsPage/components/EditDepartmentDialog.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';

export default function EditDepartmentDialog({
  open,
  onClose,
  formData,
  formErrors,
  onFormChange,
  onSubmit,
  loading,
}) {
  const { t } = useTranslation(["departments"]);

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{t('departments:form.edit_title')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label={t('departments:labels.name')}
          value={formData.name}
          onChange={onFormChange('name')}
          error={!!formErrors.name}
          helperText={formErrors.name}
          margin="normal"
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('departments:actions.cancel')}</Button>
        <Button 
          onClick={onSubmit} 
          variant="contained"
          disabled={loading}
        >
          {t('departments:actions.update')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}